import { Breadcrumb } from "@gull";
import { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import overlayFactory from "react-bootstrap-table2-overlay";
import { exportBookedFlight } from "app/services/AdminServices/bookingService";
import queryString from "app/services/queryStringService";
import { Dropdown, DropdownButton } from "react-bootstrap";
import {
  MdOutlineAirplaneTicket,
  MdSearch,
  MdSystemUpdateAlt,
} from "react-icons/md";

import HandyScroll from "app/common/Scroll";
import usePagePermission from "app/hooks/usePagePermission";
import {
  getBookingHistory,
  invoiceHandler,
  updateBooking,
} from "app/services/hotel/hotelService";
import moment from "moment";
import Tooltip from "rc-tooltip";
import { Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { AiFillFileExcel, AiOutlineCopy } from "react-icons/ai";
import { FaUserCheck } from "react-icons/fa";
import { NotificationManager } from "react-notifications";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { TbFileInvoice } from "react-icons/tb";

function BookedList() {
  const { canAdd, canView, canEdit, canDelete } = usePagePermission();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [fromDate, setFromDate] = useState();
  const [SearchBy, setSearchBy] = useState("Booking");
  const [toDate, setToDate] = useState();
  const [pnr, setPnr] = useState();
  const [modalShow, setModalShow] = useState(false);

  const dateFormatter = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <div>
        <div>{moment(cell).format("DD/MM/YYYY")}</div>
        <div>{moment(cell).format("hh:mm a")}</div>
      </div>
    );
  };

  async function invoicePrint(coRelationId) {
    const request = {
      correlationId: coRelationId,
      instantHotelMarkup: 0,
    };
    const response = await invoiceHandler(request);

    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      var blob = new Blob([response.data], { type: "application/pdf" });
      var blobURL = URL.createObjectURL(blob);
      window.open(blobURL);
    }
  }

  const priceFormatter = (cell, row) => (
    <span className="text-center">₹ {parseFloat(cell).toFixed(2)}</span>
  );
  const gatewayAndModeFormatter = (cell, row) => (
    <span
      className="text-center"
      style={{
        textTransform: "uppercase",
      }}
    >
      {cell}
    </span>
  );
  function handleJourneyClose() {
    setModalShow(false);
  }

  const selectHandler = (row) => {
    // setSelectedBooking(row);
    // setModalShow(!modalShow);

    Swal.fire({
      title: "Update Booking",
      html: `
        <div style="display: grid; gap: 15px;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <label for="hsnNo" style="min-width: 150px; font-weight: bold; font-size:15px">HSH Number</label>
            <input id="hsnNo" type="number" value="${row.hsnNo || ""}" 
              style="flex: 1; padding: 8px 10px; border: 1px solid #ccc; border-radius: 4px; font-size: 14px;" />
          </div>
          <div style="display: flex; align-items: center; gap: 10px;">
            <label for="bookingId" style="min-width: 150px; font-weight: bold;font-size:15px">Booking ID</label>
            <input id="bookingId" type="text" value="${row.bookingId || ""}" 
              style="flex: 1; padding: 8px 10px; border: 1px solid #ccc; border-radius: 4px; font-size: 14px;" />
          </div>
          <div style="display: flex; align-items: center; gap: 10px;">
            <label for="bookingStatus" style="min-width: 150px; font-weight: bold;font-size:15px">Booking Status</label>
            <select id="bookingStatus" 
              style="flex: 1; padding: 8px 10px; border: 1px solid #ccc; border-radius: 4px; font-size: 14px;">
              <option value="PENDING" ${
                row.currentStatus === "PENDING" ? "selected" : ""
              }>PENDING</option>
              <option value="COMPLETED" ${
                row.currentStatus === "COMPLETED" ? "selected" : ""
              }>COMPLETED</option>
              <option value="CANCELLED" ${
                row.currentStatus === "CANCELLED" ? "selected" : ""
              }>CANCELLED</option>
              <option value="REJECTED" ${
                row.currentStatus === "REJECTED" ? "selected" : ""
              }>REJECTED</option>
              <option value="BLOCKED" ${
                row.currentStatus === "BLOCKED" ? "selected" : ""
              }>BLOCKED</option>
            </select>
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Update",
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: async () => {
        const data = {
          id: row.id,
          bookingId: document.getElementById("bookingId").value,
          bookingStatus: document.getElementById("bookingStatus").value,
          correlationId: row.coRelationId,
          hsnNo: document.getElementById("hsnNo").value,
        };

        const res = await updateBooking(data);
        return res;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value.status === "Success") {
          Swal.fire("Success", result.value.message, "success");
          loadBookingDetails();
        } else {
          Swal.fire("Error", result.value.message, "error");
        }
      }
    });
  };

  function HotelActionButton({ row }) {
    return (
      <>
        <DropdownButton variant="outline-primary" title="Action" size="sm">
          <Dropdown.Item
            className="text-primary"
            // onClick={() => setModalShow(true)}
            onClick={() => selectHandler(row)}
          >
            <MdSystemUpdateAlt className="text-primary me-4" />
            Update Hotel Details
          </Dropdown.Item>
          <Dropdown.Item
            className="text-primary"
            onClick={() =>
              navigate(`/admin/hotel/booking-details/${row.coRelationId}`)
            }
          >
            <FaUserCheck className="text-primary me-4" />
            Booking Details
          </Dropdown.Item>
          {row.currentStatus == "COMPLETED" && (
            <Dropdown.Item
              className="text-primary"
              onClick={() => invoicePrint(row.coRelationId)}
            >
              <TbFileInvoice className="text-primary me-4" />
              Invoice
            </Dropdown.Item>
          )}
        </DropdownButton>
      </>
    );
  }

  const actionFormatter = (cell, row) => {
    return <HotelActionButton row={row} />;
  };

  const tooltipFormatter = (cell, row) => {
    return (
      cell && (
        <Tooltip
          placement="top"
          overlay={<div style={{ maxWidth: 250 }}>{cell}</div>}
        >
          {/* <span>{cell.substring(0, 10)}...</span> */}
          <span style={{ whiteSpace: "nowrap" }}>
            {cell.length > 3 ? cell.substring(0, 10) + "..." : cell}
            <AiOutlineCopy
              className="ml-1"
              style={{
                cursor: "pointer",
              }}
              onClick={async () => {
                if ("clipboard" in navigator) {
                  await navigator.clipboard.writeText(cell);
                  NotificationManager.success(
                    "Copied successfully ",
                    "Success",
                    5000
                  );
                }
              }}
            />
          </span>
        </Tooltip>
      )
    );
  };

  const columns = [
    {
      dataField: "id",
      text: "Action",
      formatter: actionFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "center" };
      },
    },

    {
      dataField: "invoiceDate",
      text: "Booking Date",
      formatter: dateFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "110px", textAlign: "center" };
      },
    },

    {
      dataField: "currentStatus",
      text: "Status",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
    },

    {
      dataField: "user.normalizedUserName",
      text: "User",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },

    {
      dataField: "invoiceAmount",
      text: "Booked Price",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
      formatter: priceFormatter,
    },

    {
      dataField: "apiGateway",
      text: "Gateway",
      formatter: gatewayAndModeFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "bookingMode",
      text: "Booking Mode",
      formatter: gatewayAndModeFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
    },
    {
      dataField: "adminMarkupAmount",
      text: "Markup",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "center" };
      },
      formatter: priceFormatter,
    },
    {
      dataField: "bookingId",
      text: "Booking Id",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
      formatter: tooltipFormatter,
    },
    {
      dataField: "coRelationId",
      text: "CoRelation Id",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
      formatter: tooltipFormatter,
    },

    {
      dataField: "refundStatus",
      text: "Refund Status",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
    },
  ];

  function rowStyle(row, rowIndex) {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    if (row.currentStatus === "REJECTED") {
      style.backgroundColor = "#DCDCDC";
    }
    return style;
  }

  function NoDataIndication() {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  }
  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "fromDate":
        setFromDate(value);
        break;
      case "toDate":
        setToDate(value);
        break;
      case "pnr":
        setPnr(value);
        break;
      case "SearchBy":
        setSearchBy(value);
        break;

      default:
        break;
    }
  };
  async function loadBookingDetails() {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      fromDate,
      toDate,
      SearchBy,
      pnr,
    });
    if (dataCount !== 0) {
      setLoading(true);
    }

    const response = await getBookingHistory(query);

    const data = response.data.data;

    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setLoading(false);
    setData(data);
    setDataCount(paggingData.TotalCount);
  }

  useEffect(() => {
    loadBookingDetails();
  }, [page, sizePerPage, fromDate, toDate, pnr, SearchBy]); // Call loadBookingDetails whenever page or sizePerPage changes

  function handleTableChange(type, { page, sizePerPage }) {
    setPage(page);
    setSizePerPage(sizePerPage);
  }

  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    setLoading(true);
    await loadBookingDetails();
  };
  const refreshFilter = (e) => {
    setFromDate("");
    setToDate("");
    setPnr("");
    setSearchBy("");
    // loadBookingDetails();
  };
  const exportAllReq = async () => {
    const query = queryString.getQueryStringFromObj({
      fromDate,
      SearchBy,
      toDate,
      pnr,
    });
    if (dataCount != 0) {
      setLoading(true);
    }

    const response = await exportBookedFlight(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${moment().toISOString()}_Flight_Booked_List.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setLoading(false);
  };
  const handleExport = async () => {
    setPage(page);
    setSizePerPage(sizePerPage);

    setTimeout(async () => {
      await exportAllReq();
    }, 10);
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <Helmet>
        <title>Booking History</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "Booking History" }]}></Breadcrumb>
      <div className="bookingList-header">
        <div className="row ">
          {/* <div className="col-md-2 col-12">
            <div className="form-group">
              <label>Search By</label>
            </div>
            <select
              className="form-control"
              name="SearchBy"
              value={SearchBy}
              onChange={handleSearchChanges}
            >
              <option value={"Booking"}>Booking</option>
              <option value={"Travel"}>Travel</option>
            </select>
          </div> */}

          <div className="col-md-5 col-12">
            <div className="form-group">
              <label> Date From</label>
            </div>
            <input
              type="date"
              className="form-control"
              name="fromDate"
              value={fromDate}
              onChange={handleSearchChanges}
              max={moment().format("YYYY-MM-DD")}
            />
          </div>
          <div className="col-md-5 col-12">
            <div className="form-group">
              <label> Date To</label>
            </div>
            <input
              type="date"
              className="form-control"
              name="toDate"
              value={toDate}
              onChange={handleSearchChanges}
              max={moment().format("YYYY-MM-DD")}
            />
          </div>
          {/* <div className="col-md-2 col-12">
            <div className="form-group">
              <label>PNR</label>
            </div>
            <input
              type="text"
              className="form-control"
              name="pnr"
              value={pnr}
              onChange={handleSearchChanges}
            />
          </div> */}
          <div
            className="col d-flex justify-content-end mb-3 col-md-2"
            style={{ marginTop: "3%" }}
          >
            <button className="btn btn-outline-primary" onClick={handleSearch}>
              <MdSearch className="" size={18} />
            </button>
            <button className="btn btn-primary mx-2" onClick={refreshFilter}>
              Refresh
            </button>
            {/* <Button
              variant="outline-primary"
              onClick={handleExport}
              disabled={!dataCount}
            >
            
              <AiFillFileExcel size={"25"} className="" />
            </Button> */}
          </div>
        </div>
      </div>
      <HandyScroll>
        <div
          className="spacious-container"
          data-handy-scroll
          style={{ overflow: "auto" }}
        >
          <BootstrapTable
            hover
            remote
            keyField="id"
            data={data}
            columns={
              canEdit ? columns : columns.filter((x) => x.text !== "Update PNR")
            }
            pagination={paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={rowStyle}
          />
        </div>
      </HandyScroll>
    </>
  );
}

export default BookedList;
